import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

const DashboardFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear(); // Get current year

  return (
    <>
      <div className="grid lg:grid-cols-[auto_1fr] grid-cols-1 lg:justify-between justify-center lg:text-left text-center lg:gap-[30px] md:gap-[15px] gap-[10px] py-[20px] px-[15px] bg-[#fff] text-white border-t border-[#DDDDDD]">
        <p className="md:text-[17px] text-[14px] text-black">
          ©{new Date().getFullYear()} {t("dashboardfooter").copyright}
        </p>
        <div className="flex gap-[6px] lg:justify-end justify-center md:text-[17px] text-[14px] text-black">
          <Link to="#">{t("dashboardfooter").helpCenter}</Link>|
          <Link to="/support">{t("dashboardfooter").contactSupport}</Link>|
          <Link to="#">{t("dashboardfooter").privacyPolicy}</Link>
        </div>
      </div>
    </>
  );
};

export default DashboardFooter;
